import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

export const fetchNotesData = createAsyncThunk(
  "getsavenotes",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/getsavenotes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const saveNotesData = createAsyncThunk(
  "savenotes",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/savenotes`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

interface NotesState {
  loading: boolean;
  data: any;
  error: string;
}

const initialState: NotesState = {
  loading: false,
  data: null,
  error: "",
};

export const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotesData.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchNotesData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = "";
      })
      .addCase(fetchNotesData.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = action.error.message || "Failed to fetch notes data";
      });
  },
});

export default notesSlice.reducer;
